import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-v2',
  templateUrl: './header-v2.component.html',
  styleUrls: ['./header-v2.component.scss', '/src/assets/css/common-v2/main-custom.scss']
})
export class HeaderV2Component {
  @Input() logoUrl: string;
  @Input() logoAlt = 'mcanism-logo';
}
